import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Entry from 'src/store/models/Entry';
import Timer from 'src/store/models/Timer';
import Project from 'src/store/models/Project';
import moment from 'moment';
import EntrySuggestion from 'src/store/models/EntrySuggestion';
import EntityTags from 'components/Entries/EntityTags';
import EntryBillingIcon from 'components/Entries/BillingIcon';
export default {
  components: {
    EntityTags: EntityTags,
    EntryBillingIcon: EntryBillingIcon
  },
  props: {
    calendarEntity: {
      type: Object,
      required: true
    },
    entityType: {
      type: String,
      required: true
    },
    displayEntityMinutes: {
      type: Number
    },
    saving: {
      type: Boolean,
      default: false
    },
    resizing: {
      type: Boolean,
      default: false
    },
    timelineMode: {
      type: Boolean,
      default: false
    },
    minified: {
      type: Boolean,
      default: false
    },
    registerTimeDialog: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      lastEntityClick: {
        clicks: 0,
        timeout: null
      },
      isMounted: false,
      showDropdown: false,
      forceResize: false,
      resizeHeight: 0,
      mouseStartY: null,
      mousePosY: null,
      onResizeThrottled: null
    };
  },
  computed: {
    entity: function entity() {
      return this.calendarEntity.event.entity ? this.calendarEntity.event.entity : this.calendarEntity.event.extendedProps.entity;
    },
    project: function project() {
      return Project.query().with('tag_lists').find(this.entity.project_id);
    },
    canSeeBilling: function canSeeBilling() {
      return this.me.is_admin || Project.$isUserPM(this.entity.project_id, this.me.user_id);
    },
    isResizing: function isResizing() {
      return this.calendarEntity.isResizing || this.resizing || this.isSaving;
    },
    isSaving: function isSaving() {
      return (this.calendarEntity.event.extendedProps ? this.calendarEntity.event.extendedProps.saving : this.calendarEntity.event.saving) || this.saving;
    },
    cardStyle: function cardStyle() {
      var style = {
        backgroundColor: this.calendarEntity.event.backgroundColor,
        borderLeft: "3px solid ".concat(this.calendarEntity.event.borderColor),
        color: this.calendarEntity.event.textColor,
        '--card-color': this.calendarEntity.event.borderColor
      };

      if (this.isMobile) {
        style.pointerEvents = 'none';
      }

      if (this.timelineMode) {
        style.minHeight = "".concat(this.minHeight, "px");
      }

      return style;
    },
    showNotes: function showNotes() {
      return (this.entity.notes || this.entity.source && this.entity.source_text || this.entity.todo && this.me.account.hasFeature('project_management')) && this.me.settings.dashboardCalendarShowNotes;
    },
    activeTimer: function activeTimer() {
      return Timer.query().where('timer_status', 'running').where('user_id', this.me.user_id).first();
    },
    isRunning: function isRunning() {
      return this.activeTimer && this.entity.timer_id === this.activeTimer.timer_id;
    },
    isTimer: function isTimer() {
      return this.entityType === 'timer';
    },
    isSuggestion: function isSuggestion() {
      return this.entityType === 'suggestion' || this.entityType === 'recurrent';
    },
    entityMinutes: function entityMinutes() {
      if (this.entityType !== 'timer') {
        var _this$entity$entry_mi;

        return parseInt((_this$entity$entry_mi = this.entity.entry_minutes) !== null && _this$entity$entry_mi !== void 0 ? _this$entity$entry_mi : this.entity.minutes);
      } else {
        var seconds = this.isRunning ? this.calendarEntity.event.id === 'local-entity' ? moment().diff(moment(this.entity.time_from), 'seconds') : this.entity.seconds + moment.utc().diff(moment.utc(this.entity.timer_start), 'seconds') : this.entity.seconds;
        return parseInt(seconds / 60);
      }
    },
    entityOriginalDuration: function entityOriginalDuration() {
      if (this.isSuggestion && this.entity.entry_minutes !== this.entity.original_duration && this.entity.source) {
        return this.entity.original_duration;
      }

      return null;
    },
    isEntityLocked: function isEntityLocked() {
      return this.entity.locked || this.calendarEntity.event.id !== 'local-entity' && this.entity.user_id !== this.me.user_id;
    },
    projectRequiresTags: function projectRequiresTags() {
      if (!this.project) return false;
      return this.project.requires_tags || this.project.tag_lists.reduce(function (acc, tagList) {
        return acc || tagList.pivot.required;
      }, false);
    },
    isEntityConfirmable: function isEntityConfirmable() {
      return this.isSuggestion && this.entityMinutes > 0 && this.entity.project_id !== -1 && this.entity.task_id !== -1 && !this.projectRequiresTags;
    },
    isNew: function isNew() {
      return !(this.entity.entry_id || this.entity.timer_id || this.entity.entry_suggestion_id || this.entity.repeatable_suggestion_id);
    },
    canEditEntity: function canEditEntity() {
      return this.isNew || Entry.isEditable(this.entity, this.me) && this.entity.user_id === this.me.user_id;
    },
    date: function date() {
      return this.entityType === 'timer' ? this.entity.timer_date : this.entity.entry_date;
    },
    minHeight: function minHeight() {
      if (this.isMounted) {
        var notesHeight = this.entity.notes.length ? 30 : 0,
            sourceHeight = this.entity.todo || this.entity.source !== '' && this.entity.source_text.length ? 30 : 0,
            tagsContainerHeight = this.entity.tags && this.entity.tags.length ? this.$refs['tags-container'] ? this.$refs['tags-container'].offsetHeight : 30 : 0;
        return 60 + notesHeight + sourceHeight + tagsContainerHeight;
      }

      return 128;
    }
  },
  methods: {
    entryDiffMinutes: function entryDiffMinutes(newMinutes, currentMinutes) {
      return newMinutes - currentMinutes;
    },
    editEntity: function editEntity() {
      this.openDialog('RegisterTimeDialog', {
        type: this.entityType,
        entity: this.entity
      });
    },
    copyEntity: function copyEntity() {
      this.openDialog('RegisterTimeDialog', {
        type: this.entityType,
        entity: this.entity,
        copy: true
      });
    },
    onUpdateTimerStatus: function onUpdateTimerStatus() {
      var _this = this;

      var timer = Timer.find(this.entity.timer_id);
      timer.$toggleStatus().then(function () {
        _this.$q.notify({
          message: timer.timer_status === 'running' ? _this.$t('timer.timer_paused') : _this.$t('timer.timer_started'),
          type: 'positive'
        });
      }).catch(function () {});
    },
    saveSuggestionAsEntry: function saveSuggestionAsEntry() {
      var _this2 = this;

      this.$emit('update:saving', true);
      Entry.api().store(_objectSpread(_objectSpread({}, this.entity), {}, {
        repeatable_suggestion_id: this.entity.repeatable_suggestion_id ? this.entity.repeatable_suggestion_id : null,
        entry_suggestion_id: this.entity.repeatable_suggestion_id ? null : this.entity.entry_suggestion_id,
        type: this.entity.type ? this.entity.type : 'suggestion',
        date: this.entity.entry_date,
        suggested_project_id: this.type === 'suggestion' ? this.entity.project_id : null,
        suggested_task_id: this.type === 'suggestion' ? this.entity.task_id : null,
        phase_id: this.entity.task_id > 0 ? this.entity.task_id : -1,
        minutes: this.entity.entry_minutes,
        platform: 'v3',
        platform_details: 'saveSuggestionAsEntry'
      })).then(function () {
        if (_this2.isSuggestion) {
          EntrySuggestion.delete(_this2.entity.entry_suggestion_id);
        }

        _this2.$q.notify({
          message: _this2.$t('suggestion.suggestion_accepted'),
          type: 'positive'
        });
      }).catch(function () {}).finally(function () {
        _this2.saving = false;
      });
    },
    onSaveTimerAsAnEntry: function onSaveTimerAsAnEntry() {
      var _this3 = this;

      var timer = Timer.find(this.entity.timer_id);
      timer.$saveAsAnEntry({}).then(function () {
        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          window.ueuq = window.uetq || [];
          window.ueuq.push('event', 'entry_save', {}); // HUBSPOT

          window._hsq.push(['setPath', 'entry/save']);

          window._hsq.push(['trackPageView']);

          if (_this3.$gtag) {
            _this3.$gtag.event('entry_save', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
              debug_mode: true
            } : {});
          }
        }

        _this3.$q.notify({
          message: _this3.$t('timer.timer_saved_as_entry'),
          type: 'positive'
        });
      }).catch(function () {});
    },
    deleteEntity: function deleteEntity() {
      var _this4 = this;

      if (this.entityType === 'entry') {
        var entry = Entry.find(this.entity.entry_id);

        if (entry.platform === 'demodata' && this.me.settings.showDeleteDemoDialog) {
          this.openDialog('deleteDemoDialog', {
            type: this.entityType,
            entity: this.entity
          });
        } else {
          this.$emit('update:saving', true);
          entry.$delete().then(function () {
            _this4.$q.notify({
              message: _this4.$t('general.deleted_entry'),
              type: 'positive'
            });
          }).catch(function () {}).finally(function () {
            _this4.saving = false;
          });
        }
      } else if (this.entityType === 'timer') {
        var timer = Timer.find(this.entity.timer_id);

        if (timer.platform === 'demodata' && this.me.settings.showDeleteDemoDialog) {
          this.openDialog('deleteDemoDialog', {
            type: this.entityType,
            entity: this.entity
          });
        } else {
          this.$emit('update:saving', true);
          timer.$delete().then(function () {
            _this4.$q.notify({
              message: _this4.$t('general.deleted_timer'),
              type: 'positive'
            });
          }).catch(function () {}).finally(function () {
            _this4.saving = false;
          });
        }
      } else if (this.isSuggestion) {
        var suggestion = EntrySuggestion.find(this.entity.entry_suggestion_id);

        if (suggestion.type === 'recurrent') {
          this.openDialog('RecurrentSuggestionDeleteDialog', {
            onDelete: function onDelete(choice) {
              _this4.$emit('update:saving', true);

              if (choice === '1') {
                suggestion.$ignore().then(function () {
                  _this4.$q.notify({
                    message: _this4.$t('general.deleted_suggestion'),
                    type: 'positive'
                  });
                }).finally(function () {
                  _this4.saving = false;
                });
              } else {
                suggestion.$delete().then(function () {
                  _this4.$q.notify({
                    message: _this4.$t('general.deleted_suggestion'),
                    type: 'positive'
                  });
                }).finally(function () {
                  _this4.saving = false;
                });
              }
            }
          });
        } else {
          this.$emit('update:saving', true);
          suggestion.$delete().then(function () {
            _this4.$q.notify({
              message: _this4.$t('general.deleted_suggestion'),
              type: 'positive'
            });
          }).finally(function () {
            _this4.saving = false;
          });
        }
      }
    },
    goToProject: function goToProject() {
      if (this.minified) return;
      this.$router.push({
        name: 'project_detail',
        params: {
          project_id: this.entity.project_id
        }
      });
    },
    createTimerFromEntry: function createTimerFromEntry(entry) {
      var _this5 = this;

      Timer.api().post('/timers', {
        project_id: entry.project_id,
        user_id: entry.user_id,
        task_id: entry.task_id,
        phase_id: entry.task_id,
        date: entry.entry_date,
        tag_ids: entry.tag_ids,
        notes: entry.notes,
        source: entry.source,
        source_text: entry.source_text,
        source_url: entry.source_url,
        source_data: entry.source_data,
        source_id: entry.source_id,
        todo_id: entry.todo_id,
        seconds: 0
      }).then(function () {
        if (process.env.GOOGLE_ANALYTICS_ENABLED) {
          window.ueuq = window.uetq || [];
          window.ueuq.push('event', 'timer_start', {});

          if (_this5.$gtag) {
            _this5.$gtag.event('timer_start', process.env.GOOGLE_ANALYTICS_DEBUGMODE ? {
              debug_mode: true
            } : {});
          }
        }

        _this5.$q.notify({
          type: 'positive',
          message: _this5.$t('timer.timer_started')
        }); // this.$root.$emit('refresh-calendar')

      }).catch(function (e) {
        _this5.loading = false;
      });
    },
    onClick: function onClick() {
      var _this6 = this;

      this.lastEntityClick.clicks++;

      if (this.lastEntityClick.clicks === 2) {
        clearTimeout(this.lastEntityClick.timeout);
        this.lastEntityClick.clicks = 0;

        if (this.entityType === 'entry') {
          var entry = Entry.find(this.entity.entry_id);

          if (entry && !entry.locked_by_apionly) {
            this.createTimerFromEntry(entry);
          } else {
            this.$q.notify({
              timeout: 3000,
              color: 'negative',
              message: this.$t('general.linked_project_api_only.body', {
                0: this.$t('general.linked_project_api_only.api_only')
              })
            });
          }
        } else {
          this.onUpdateTimerStatus();
        }
      } else {
        if (this.lastEntityClick.timeout) {
          clearTimeout(this.lastEntityClick.timeout);
        }

        this.lastEntityClick.timeout = setTimeout(function () {
          _this6.lastEntityClick.clicks = 0;
        }, 400);
      }
    },
    onLink: function onLink() {
      window.open(this.entity.source_url, 'blank');
    }
  },
  mounted: function mounted() {
    this.isMounted = true;
  }
};